import * as React from 'react';
import Stack from '../../Stack/index.js';
import { OptionGroup, Label, StepButton, ChevronRight, ButtonText } from '../Form.styles.js';
import Typography from '../../Typography/index.js';

var StepButtons = function StepButtons(_ref) {
  var name = _ref.name,
    instructions = _ref.instructions,
    label = _ref.label,
    options = _ref.options,
    nextStep = _ref.nextStep;
  return /*#__PURE__*/React.createElement(OptionGroup, {
    gridArea: name
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, instructions), /*#__PURE__*/React.createElement(Label, null, label), /*#__PURE__*/React.createElement(Stack, {
    spacing: "sm"
  }, options.map(function (_ref2) {
    var displayName = _ref2.displayName,
      optionLabel = _ref2.label,
      optionName = _ref2.name,
      value = _ref2.value;
    return /*#__PURE__*/React.createElement(StepButton, {
      key: optionName,
      variant: "default",
      rightIcon: /*#__PURE__*/React.createElement(ChevronRight, {
        size: "1.5em"
      }),
      gridArea: optionName,
      onClick: function onClick(e) {
        return nextStep(e, name, value);
      }
    }, /*#__PURE__*/React.createElement(ButtonText, null, displayName || optionLabel));
  })));
};
var StepButtons$1 = StepButtons;

export { StepButtons$1 as default };
//# sourceMappingURL=StepButtons.js.map
